import React from 'react';

const Instruction = () => {
    return (
        <div>
            
        </div>
    );
};

export default Instruction;